import { render, staticRenderFns } from "./charges-specifiques.vue?vue&type=template&id=4ee96f92"
import script from "./charges-specifiques.vue?vue&type=script&lang=js"
export * from "./charges-specifiques.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports